import { Checkbox, Descriptions, Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import svg38 from "../../../../../assets/svg/svg38.svg";
import MaterialIcon from "material-icons-react";
import {
  dateForHumans,
  formatMoney,
  numberWithCommas,
  timeAmPm,
} from "../../../../../utils";
import withdrawal from "../../../../../assets/svg/withdrawalSvg.svg";
import InsideHeader from "../../../../../components/InsideHeader";
import FilterModal from "./FilterModal";
import SinglePaymentModal from "../modal/SinglePaymentModal";
import svg56 from "../../../../../assets/svg/svg56.svg";
import svg27 from "../../../../../assets/svg/svg27.svg";
import DeleteModal from "../../../../../components/DeleteModal";
import toast from "react-hot-toast";
import { save } from "../../../../../features/save/saveSlice";
import ConfirmSubmitModal from "../../../../../components/ConfirmSubmitModal";
import { fetchPaymentDetails } from "../../../../../features/dropdown/dropdownSlice";
import PaymentDetailsModal from "./modal/PaymentDetailsModal";
import { deletePaymentDetails } from "../../../../../features/staff-setting/staffSettingSlice";
import OtpModal from "../modal/OtpModal";
import verifiedPng from "../../../../../assets/img/verified.png";
import CardLoading from "../../../../../components/CardLoading";
import svg66 from "../../../../../assets/svg/svg66.svg";

export default function DirectPaymentDetailsTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { paymentDetails, loading, paymentDetailsCount, staffloading } =
    useSelector((state) => state.dropdown);
  const { directHeaderObj } = useSelector((state) => state.folder);
  const { saving } = useSelector((state) => state.save);

  const [searchText, setSearchText] = useState("");

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }

  const [openSingle, setopenSingle] = useState(false);
  async function handleCancelSingle() {
    await setProdd("");
    await setopenSingle(false);
  }
  async function handleOpenSingle() {
    await setProdd("");
    await setopenSingle(true);
  }

  const handleEditSingle = () => {
    setopenSingle(true);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      deletePaymentDetails({
        pdId: prodd?.pdId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await fetchPaymentDetailsData();
      await setIsModalOpenDelete(false);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };
  const [filters, setFilters] = useState([]);
  const [formData, setFormData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModalFilter = () => {
    setIsModalOpen(true);
  };

  const handleClearFilters = async () => {
    await setFormData({});
    await dispatch(fetchPaymentDetails());
    await setFilters([]);
  };
  const [isModalOpenSubmit, setIsModalOpenSubmit] = useState(false);
  const [isModalOpenSubmitVerify, setIsModalOpenSubmitVerify] = useState(false);

  const [prodd, setProdd] = useState("");
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  const [openOtp, setopenOtp] = useState(false);
  async function handleCancelOtp() {
    await setopenOtp(false);
    await setIsModalOpenSubmit(true);
  }

  async function handleOpenOtp() {
    const res = await dispatch(
      save({
        url: `py/sendOtp.action`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await setopenOtp(true);
      await setIsModalOpenSubmit(false);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  }

  async function handleVerifyAcnts() {
    const res = await dispatch(
      save({
        url: `py/verifyPaymentAccounts.action?phId=${directHeaderObj?.phId}`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await setopenOtp(false);
      await setIsModalOpenSubmitVerify(false);
      await navigate("/direct-payment-details");
      await fetchPaymentDetailsData();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  }

  const handleConfirmation = async () => {
    await setIsModalOpenSubmit(true);
  };

  async function handleOpenVerify() {
    await setIsModalOpenSubmitVerify(true);
  }

  const handleSubmit = async () => {
    const res = await dispatch(
      save({
        url: `py/disbursePayment.action?phId=${directHeaderObj?.phId}`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await setopenOtp(false);
      await setIsModalOpenSubmit(false);
      await navigate("/direct-payment");
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const columns = [
    {
      title: "Amount",
      dataIndex: "pdAmount",
      sorter: (a, b) => a.pdAmount - b.pdAmount,
    },
    {
      title: "Account",
      dataIndex: "pdReceiverNumber",
      sorter: (a, b) => a.pdReceiverNumber - b.pdReceiverNumber,
    },
    {
      title: "Bank Name",
      dataIndex: "pdBankName",
      sorter: (a, b) => a.pdBankName.localeCompare(b.pdBankName),
    },
    {
      title: "Bank Code",
      dataIndex: "pdBankCode",
      sorter: (a, b) => a.pdBankCode.localeCompare(b.pdBankCode),
    },
    {
      title: "Payee Type",
      dataIndex: "pdPayeeType",
      sorter: (a, b) => a.pdPayeeType.localeCompare(b.pdPayeeType),
    },
    {
      title: "Receiver Name",
      dataIndex: "pdReceiverName",
      sorter: (a, b) => a.pdReceiverName.localeCompare(b.pdReceiverName),
    },
    {
      title: "Status",
      dataIndex: "pdStatus",
      render: (item) => {
        return (
          <div
            className={`${
              item === "PENDING_PAYMENT"
                ? "bg-[#FFB74D]"
                : item === "FAILED"
                ? "bg-[#FF4D4F]"
                : item === "PROCESSING"
                ? "bg-[#FFC107]"
                : item === "COMPLETED"
                ? "bg-darkGreen"
                : null
            }  text-[#FFf] font-[700] inline-block rounded-[5px] px-2 py-1 w-auto`}
          >
            {item}
          </div>
        );
      },
    },
    {
      title: "Transaction Type",
      dataIndex: "pdTransType",
      sorter: (a, b) => a.pdTransType.localeCompare(b.pdTransType),
    },
    {
      title: "National ID",
      dataIndex: "idNumber",
      sorter: (a, b) => a.idNumber - b.idNumber,
    },

    {
      title: "Number Verification",
      dataIndex: "isReceiverNumberVerified",
      render: (item) => {
        return (
          <div>
            {item == null || item == false ? (
              <Checkbox checked={false}></Checkbox>
            ) : item == true ? (
              <Checkbox checked={true}></Checkbox>
            ) : null}
          </div>
        );
      },
      sorter: (a, b) =>
        a.isReceiverNumberVerified.localeCompare(b.isReceiverNumberVerified),
    },
    {
      title: "Verified Receiver Name",
      dataIndex: "verifiedReceiverName",
      sorter: (a, b) =>
        a.verifiedReceiverName.localeCompare(b.verifiedReceiverName),
    },

    {
      title: "Ndovupay Status",
      dataIndex: "pdNdovupayStatus",
      render: (item) => {
        return (
          <div
            className={`${
              item === "PENDING_PAYMENT"
                ? "bg-[#FFB74D]"
                : item === "FAILED"
                ? "bg-[#FF4D4F]"
                : item === "PROCESSING"
                ? "bg-[#FFC107]"
                : item === "COMPLETED"
                ? "bg-darkGreen"
                : item === "QUEUED"
                ? "bg-[#90CAF9]"
                : null
            }  text-[#FFf] font-[700] inline-block rounded-[5px] px-2 py-1 w-auto`}
          >
            {item}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const items = [
    {
      key: "1",
      label: "Ph No",
      children: directHeaderObj?.phNo,
    },
    {
      key: "2",
      label: "Created Date",
      children: <div>{dateForHumans(directHeaderObj?.phCreatedDate)}</div>,
    },
    {
      key: "3",
      label: "Created Time",
      children: <div>{timeAmPm(directHeaderObj?.phCreatedTime)}</div>,
    },
    {
      key: "4",
      label: "Type",
      children: directHeaderObj?.phType,
    },
    {
      key: "5",
      label: "Description",
      children: directHeaderObj?.phPaymentDesc,
    },
    {
      key: "6",
      label: "Status",
      children: directHeaderObj?.phStatus,
    },
  ];

  const settingItemsQuickActions = [
    {
      key: "1",
      label: (
        <Link
          onClick={
            directHeaderObj?.phStatus === "COMPLETED"
              ? null
              : handleConfirmation
          }
          className={`${
            directHeaderObj?.phStatus === "COMPLETED"
              ? "cursor-not-allowed"
              : "cursor-pointer"
          } flex  text-[16px] font-sans  !text-lightBlack py-1`}
        >
          {directHeaderObj?.phStatus === "COMPLETED"
            ? "Already Disbursed"
            : " Disburse Payment"}
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          onClick={handleOpenSingle}
          className="flex  text-[16px] font-sans  !text-lightBlack py-1"
        >
          Add details
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          onClick={handleOpenVerify}
          className="flex  text-[16px] font-sans  !text-lightBlack py-1"
        >
          Verify Accounts
        </Link>
      ),
    },
  ];

  const settingItems = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleEditSingle}
          className="flex  text-[16px] font-sans  !text-lightBlack py-1"
        >
          Edit
        </Link>
      ),
    },

    {
      key: "2",
      label: (
        <div
          onClick={showModalDelete}
          className="flex  text-[16px] font-sans   !text-lightBlack py-1"
        >
          Delete
        </div>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchPaymentDetailsData(page, size) {
    dispatch(
      fetchPaymentDetails({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        phId: directHeaderObj?.phId,
      })
    );
  }

  useEffect(() => {
    fetchPaymentDetailsData();
  }, []);

  if (loading) return <CardLoading />;

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Payment Details"
        subtitle="Manage payment details within your payment header"
        back={true}
        title1="Payment Headers"
        title2="Payments Details"
      />

      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <div className="mt-[1.25rem]">
            <Descriptions
              column={2}
              colon={false}
              title="Payment Header Information"
              items={items}
            />
          </div>
          <div className="flex justify-between items-center">
            <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
              Payment Details
            </h3>
          </div>
          <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
            <div className="flex items-center">
              <span>
                {" "}
                <button
                  onClick={showModalFilter}
                  type="button"
                  className={`bg-transparent flex items-center gap-x-'1' ${
                    Object?.keys(formData)?.length > 0
                      ? "!text-[#5688E5]"
                      : "inherit"
                  }`}
                >
                  <MaterialIcon color="#141414" icon="filter_list" />
                  Filters
                </button>
              </span>
              {Object?.keys(formData)?.length > 0 && (
                <span className="flex items-center text-[#5688E5] cursor-pointer ml-1">
                  :{Object?.keys(formData)?.length}
                  <img src={svg38} alt="svg38" onClick={handleClearFilters} />
                </span>
              )}
            </div>
            <Dropdown
              overlayStyle={{
                width: "250px",
              }}
              trigger={"click"}
              menu={{ items: settingItemsQuickActions }}
              placement="bottom"
            >
              <div className="w-[200px]">
                <button className="cstm-btn flex gap-x-2" type="submit">
                  <img src={svg56} alt={svg56} /> Quick actions
                </button>
              </div>
            </Dropdown>
          </div>
          <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
            <section>
              <Table
                rowSelection={false}
                className="mt-[1.31rem] w-full"
                scroll={{
                  x: 800,
                }}
                rowKey={(record) => record?.pdId}
                columns={columns}
                dataSource={paymentDetails}
                loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  total: paymentDetailsCount,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchPaymentDetailsData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </div>
      </div>

      <FilterModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        formData={formData}
        setFormData={setFormData}
        filters={filters}
        setFilters={setFilters}
        year={directHeaderObj?.fpPyear}
        month={directHeaderObj?.fpPmonth}
      />

      <PaymentDetailsModal
        handleFetchData={fetchPaymentDetailsData}
        open={openSingle}
        setopenSingle={setopenSingle}
        handleCancel={handleCancelSingle}
        prodd={prodd}
        phPayeeType={directHeaderObj?.phPayeeType}
        pdPhId={directHeaderObj?.phId}
      />

      <DeleteModal
        isModalOpen={isModalOpenDelete}
        setIsModalOpen={setIsModalOpenDelete}
        prodd={prodd}
        handleDelete={handleDelete}
        loading={staffloading}
        content={`Are you sure you want to delete detail of amount ${numberWithCommas(
          prodd?.pdAmount
        )}?`}
        title={`Delete amount ${numberWithCommas(prodd?.pdAmount)}`}
      />

      <ConfirmSubmitModal
        isModalOpen={isModalOpenSubmit}
        setIsModalOpen={setIsModalOpenSubmit}
        handleSubmit={handleOpenOtp}
        loading={saving}
        content={`Are you sure you want to disburse payment for header ${directHeaderObj?.phNo} `}
      />

      <ConfirmSubmitModal
        isModalOpen={isModalOpenSubmitVerify}
        setIsModalOpen={setIsModalOpenSubmitVerify}
        handleSubmit={handleVerifyAcnts}
        loading={saving}
        content={`Are you sure you want to verify account details for ${directHeaderObj?.phNo} `}
      />

      <OtpModal
        title={`Verify your transaction for ${directHeaderObj?.phNo}`}
        handleFetchData={fetchPaymentDetailsData}
        open={openOtp}
        handleCancel={handleCancelOtp}
        handleSubmit={handleSubmit}
      />
    </div>
  );
}
